module.exports = __webpack_public_path__ + "img/android-chrome-192x192.6e1d27ab.png";